import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ActionFormField, ActionFormRequest } from '../../models/chat.model';

@Component({
  selector: 'app-chat-action-form',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './chat-action-form.component.html',
  styleUrl: './chat-action-form.component.scss',
})
export class ChatActionFormComponent implements OnInit {
  @Input({ required: true }) formDef!: ActionFormRequest;
  @Input() submitted = false;

  @Output() formSubmit = new EventEmitter<Record<string, string>>();

  values: Record<string, string> = {};
  errors: Record<string, boolean> = {};

  ngOnInit() {
    // Pre-populate with prefilled values and field defaults
    for (const field of this.formDef.fields) {
      this.values[field.key] =
        this.formDef.prefilled[field.key] ??
        field.default ??
        '';
    }
  }

  fieldType(field: ActionFormField): string {
    if (field.type === 'textarea' || field.type === 'select') return field.type;
    return field.type; // text | date | url
  }

  submit() {
    this.errors = {};
    let valid = true;
    for (const field of this.formDef.fields) {
      if (field.key === 'project_name') continue; // auto-filled, always valid
      if (field.required && !this.values[field.key]?.trim()) {
        this.errors[field.key] = true;
        valid = false;
      }
    }
    if (!valid) return;
    this.formSubmit.emit({ ...this.values });
  }

  trackByKey(_: number, field: ActionFormField) {
    return field.key;
  }
}
